import axios from 'axios';
import store from '@/store';
import SettingMer from '@/libs/settingMer';
import Tips from '@/utils/tips';
var instance = axios.create({
  baseURL: SettingMer.https,
  timeout: 60000
});
var defaultOpt = {
  login: true
};
function baseRequest(options) {
  var token = store.getters.token;
  var headers = options.headers || {};
  var lang = store.getters.lang || 'zh-cn';
  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }
  headers['laravel_lang'] = lang;
  options.headers = headers;

  // 后期修改成这个方法
  return new Promise(function (resolve, reject) {
    instance(options).then(function (res) {
      var data = res.data || {};
      if (res.status !== 200) {
        return reject({
          message: '请求失败',
          res: res,
          data: data
        });
      } else if ([410000, 410001, 410002, 40000, 410003].indexOf(data.status) !== -1) {
        store.dispatch('user/resetToken').then(function () {
          location.pathname !== '/admin/login' && location.reload();
        });
      } else if (data.status === 200) {
        if (data.tips && data.message !== 'ok') {
          Tips.msgSuccess(data.message);
        }
        return resolve(data);
      } else if (data.status === 400) {
        if (data.tips && data.message !== 'error') {
          Tips.msgError(data.message);
        }
        return resolve(data, res);
      } else if (data.status === 410005) {} else {
        return reject({
          message: data.message,
          res: res,
          data: data
        });
      }
    }).catch(function (message) {
      return reject({
        message: message
      });
    });
  });
}
/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
var request = ['post', 'put', 'patch', 'delete'].reduce(function (request, method) {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = function (url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return baseRequest(Object.assign({
      url: url,
      data: data,
      method: method
    }, defaultOpt, options));
  };
  return request;
}, {});
['get', 'head'].forEach(function (method) {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = function (url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return baseRequest(Object.assign({
      url: url,
      params: params,
      method: method
    }, defaultOpt, options));
  };
});
export default request;